module.exports = __webpack_public_path__ + "static/img/ngzg_new.23ce59c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngzg_new.jpg
// module id = Pi3a
// module chunks = 3